import React from 'react';
import { Container } from 'reactstrap';
import { Helmet } from 'react-helmet';
import './PrivacyPolicy.scss';
import iconLogo from '../../../images/icon-logo.png';

const PrivacyPolicy = () => (
    <Container className="privacy-policy-container">
        <Helmet>
            <meta charSet="utf-8" />
            <title>NFFS ICON - Privacy Policy</title>
            <meta
                name="description"
                content="Privacy Policy for the ICON Portal managed by NFFS."
            />
        </Helmet>

        <img src={iconLogo} alt="ICON Logo" style={{ display: 'block', margin: '0 auto 24px', maxWidth: 250 }} />
        <div className="privacy-content">
            <h1>Privacy and Policy Statement</h1>
            <p className="last-updated">Last Updated: 4/30/2021</p>

            <section>
                <p className="mb-4">
                    ICON portal is committed to keeping any and all personal
                    information collected of our users/ individuals, secure and private. Our Privacy policy has been designed
                    and created to ensure those affiliated with ICON of our commitment and realization of our obligation
                    not only to meet; but, to exceed most existing privacy standards.
                </p>

                <p className="mb-4">
                    <b>THEREFORE</b>, this Privacy Policy Agreement shall apply to the ICON portal, and thus it shall govern any
                    and all data collection and usage thereof. Through the use of <a href="https://iconportal.com" target="_blank" rel="noopener noreferrer">https://iconportal.com</a> you are herein
                    consenting to the following data procedures expressed within this agreement.
                </p>
            </section>

            <section>
                <h2>Collection of Information</h2>
                <p>This website collects various types of information, such as:</p>
                <ul>
                    <li>Voluntarily provided information which may include your Organization Name, your individual
                        name, address of Organization, telephone number and email address and as ICON expansion is
                        created the applicable billing and /or invoicing details of procurements.</li>
                    <li>Information automatically collected when visiting our website, which may include cookies, third
                        party tracking technologies and server logs</li>
                </ul>
                <p>
                    Please rest assured that this site shall only collect personal information that you knowingly and willingly
                    provide by way of surveys, completed membership/registration forms, and emails. It is the intent of this
                    site to use personal information only for the purpose for which it was requested and any additional uses
                    specifically provided on the ICON site.
                </p>
                <p>
                    ICON may have the occasion to collect demographic information, such as additional Organization
                    preferences, name changes, bid matching and supplier tooling/capabilities. We may also gather
                    information about the type of browser you are using, IP address or type of operating system to assist us
                    in providing and maintaining superior quality service.
                </p>
                <p>
                    It is highly recommended that you review the privacy policies and statements on any website you
                    choose to use or frequent as a means to better understand the way in which other websites garner and
                    make use of the shared information collected.
                </p>
            </section>

            <section>
                <h2>Use of Information Collected</h2>
                <p>
                    ICON may collect and may make use of personal information to assist in the operation of our website
                    and to ensure delivery of the services you need and request. At times, we may find it necessary to use
                    personally identifiable information (PII) as a means to keep you informed of other possible products
                    and/or services that may be available to you from <a href="https://iconportal.com" target="_blank" rel="noopener noreferrer">https://iconportal.com</a>. ICON may also be in contact
                    with you in regards to completing surveys and/or research questionnaires related to your opinion of
                    current or potential future services that may be offered.
                </p>
                <p>
                    ICON does not now, but reserves the right in the future to sell, rent or lease any of our customer lists
                    and/or names to any third party.
                </p>
                <p>
                    ICON may deem it necessary to follow websites and/or pages that users may frequent in an effort to
                    glean what types of services and/or products may be the most popular to customers or the public.
                </p>
                <p>
                    ICON may disclose your personal/organizational information, without prior notice to you, ONLY if
                    required to do so in accordance with applicable laws and/or in a good faith belief that such action is
                    deemed necessary or is required in an effort to:
                </p>
                <ul>
                    <li>Remain in compliance with any decrees, laws and/or statutes or in an effort to comply
                        with any process which may be served upon ICON, and/or;</li>
                    <li>Maintain safeguard and/or preserve all the rights and/or property of ICON, and</li>
                    <li>Perform under demanding conditions in an effort to safeguard the personal safety of
                        users of <a href="https://iconportal.com" target="_blank" rel="noopener noreferrer">https://iconportal.com</a> and/or general public.</li>
                </ul>
            </section>

            <section>
                <h2>Unsubscribe or Opt-Out</h2>
                <p>
                    All users and/or visitors to our website have the option to discontinue receiving communication from us
                    and/or reserve the right to discontinue receiving communications by way of email or newsletters. To
                    discontinue or unsubscribe to our website please send an email that you wish to unsubscribe/register to <a href="mailto:support@iconportal.com?bcc=support@nffs.atlassian.net&subject=IT%20Support%20Request%20-%20ICON%20Portal&body=Please%20describe%20your%20request%20or%20issue%20below%3A%0A%0A">support@iconportal.com</a>. If you wish to
                    unsubscribe/register or opt-out from any third- party websites, you must go to that specific website to unsubscribe and/or opt-out.
                </p>
            </section>

            <section>
                <h2>Links to Other Web Sites</h2>
                <p>
                    Our website does contain links to affiliate and other websites. ICON does not claim nor accept
                    responsibility for any privacy policies, practices and /or procedures of other such websites. Therefore,
                    we encourage all users and visitors to be aware when they leave our website and to read the privacy
                    statements of each and every website that collects personally identifiable information (PII). The
                    aforementioned Privacy Policy Agreement applies only and solely to the information collected by our
                    website.
                </p>
            </section>

            <section>
                <h2>Security</h2>
                <p>
                    ICON shall endeavor and shall take every precaution to maintain adequate physical, procedural and
                    technical security with respect to our offices and information storage facilities (servers) so as to prevent
                    any loss, misuse, unauthorized access, disclosure or modification of the user&apos;s personal/organizational
                    information under our control. The company (ICON) site uses Secure Socket Layer (SSL) for
                    authentication and private communications in an effort to build users&apos; trust and confidence in the
                    internet and website domain by providing simple and secure access and communication of
                    data/information.
                </p>
            </section>

            <section>
                <h2>Changes in Policy Agreement</h2>
                <p>
                    ICON reserves the right to update and/or change the terms of our privacy policy, and as such we will
                    post those changes to our website homepage at <a href="https://iconportal.com" target="_blank" rel="noopener noreferrer">https://iconportal.com</a> so that our users and/or
                    visitors are always aware of the type of information we collect, how it will be used, and under what
                    circumstances, if any, we may disclose such information. If at any point in time ICON decides to make
                    use of any personally identifiable information on file, in a manner vastly different from that which was
                    stated when this information was initially collected, the user or users shall be promptly notified by
                    email. Users at that time shall have the option as to whether or not to permit the use of their
                    information in this separate manner.
                </p>
            </section>

            <section>
                <h2>Acceptance of Terms</h2>
                <p>
                    Through the use of the ICON website, you are hereby accepting the terms and conditions stipulated
                    within the aforementioned Privacy Policy Agreement. If you are not in agreement with our terms and
                    conditions, then you should refrain from further use of our site. In addition, your continued use of our
                    website following the posting of any updates or changes to our terms and conditions shall mean that
                    you are in agreement and acceptance of such changes.
                </p>
            </section>

            <section>
                <h2>How to Contact Us</h2>
                <p>
                    If you have any questions or concerns regarding the Privacy Policy Agreement related to our website,
                    please feel free to contact us at the following email, telephone number or mailing address.
                </p>
                <div className="contact-info">
                    <p>Email: <a href="mailto:support@iconportal.com?bcc=support@nffs.atlassian.net&subject=IT%20Support%20Request%20-%20ICON%20Portal&body=Please%20describe%20your%20request%20or%20issue%20below%3A%0A%0A">support@iconportal.com</a></p>
                    <p>Telephone: 847.299.0950</p>
                    <p>
                        Mailing:<br />
                        Non-Ferrous Founders&#39; Society<br />
                        6128 Beckley Dr. North #1034<br />
                        Battle Creek, MI 49014<br />
                        United States
                    </p>
                </div>
            </section>
        </div>
    </Container>
);

export default PrivacyPolicy; 


// WEBPACK FOOTER //
// ./src/pages/static/PrivacyPolicy/PrivacyPolicy.jsx